import {
  Component,
  ViewChildren,
  QueryList,
  OnInit,
} from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import { environment } from 'src/environments/environment';
import { MAX_SIZE } from 'src/app/onelog/common/config/common';
import { TRADE_SALE } from 'src/app/onelog/common/config/url';
import { DateSelectComponent } from 'src/app/onelog/common/fields/date-select/date-select.component';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { CustomEvents} from 'src/app/onelog/classes/CustomEvent'
import { FilterDataTradeSale, ResponsePaginated} from 'src/app/onelog/interface/CustomTypes';

@Component({
  selector: 'app-trade-sale',
  templateUrl: './trade-sale.component.html',
  styleUrls: ['./trade-sale.component.css']
})
export class TradeSaleComponent implements OnInit {

  @ViewChildren(DateSelectComponent) NgbDate!: QueryList<DateSelectComponent>;

  constructor(
    private requestService: RequestService,
  ) {}

  apiURL = environment.sachWebURL;
  selectedproductId: string = '';
  orders: any = [];
  totalOrders: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 1;
  showSearchLoading: boolean = false;
  pageSize: number = 25;
  maxSize: number = MAX_SIZE;
  searchBtnText: string = 'Search';
  responseData: any = [];
  selectStarFilterDate: any = [];
  filterData : Partial<FilterDataTradeSale> = {
    tradeSale : {}
  };
  selectEndFilterDate: any = [];
  errorToastShow: boolean = false;
  
  ngOnInit(): void {
    this.filterData['tradeSale'] = {};
    this.getOrders(this.createPostData());
  }

  // Fetches trade sale orders from the backend and updates the component state.
  getOrders(postData: any = [], url: string = TRADE_SALE) {
    return this.requestService
      .postRequest(url, postData)
      .subscribe((data: {}) => {
        let responseData : ResponsePaginated = data
        this.orders = responseData.data;
        this.searchBtnText = 'Search';
        this.showSearchLoading = false;
        this.setPaginationData(responseData);
      }, (error: any) => {
        this.errorToastShow = true;
        this.showSearchLoading = false;
      });
  }

  setPaginationData(responseData : any){
    this.totalOrders = responseData.total;
    this.perPage = responseData.per_page;
    this.lastPage = Math.floor(this.totalOrders / this.perPage) + 1;
    this.currentPage = responseData.current_page;
  }

  createPostData() {
    return {
      selectedDate: Object.assign({}, this.filterData),
      page: this.currentPage,
    };
  }

  // Downloads the trade sale report as an Excel file.
  downloadReport() {
      this.requestService.download(
      TRADE_SALE,
      {
        is_download: 1,
        selectedDate: Object.assign({}, this.filterData),
        page: this.currentPage,
      },
      '',
      'trade_sale_report'
    );
  }

  searchOrders() {
    this.searchBtnText = 'Searching...';
    this.getOrders(this.createPostData());
  }

  updateSelectedDate(event: CustomEvents) {
    
    if (event.type == 'tradeSaleStartDate') {
      this.filterData['tradeSale'] = this.filterData['tradeSale'] || {};
      this.filterData['tradeSale']['startDate'] =  event.dateString;
    }

    if (event.type == 'tradeSaleEndDate') {
      this.filterData['tradeSale'] = this.filterData['tradeSale'] || {};
      this.filterData['tradeSale']['endDate'] =  event.dateString;
    }

  }

  updatePageData(event: CustomEvents) {
    let eventData: any = event;
    this.currentPage = eventData.currentPage;
    this.getOrders(this.createPostData());
  }

  clearFilters() {
    this.clearAllDates();
  }

  clearAllDates(): void {
    this.NgbDate.forEach((datePickerComp) => {
      datePickerComp.clearDate();
    });

    this.filterData['tradeSale'] = {};
  }

}
